<template>
  <div class="connect">
    <div class="alertContainer">
      <el-alert
        class="alert alert-info"
        title="You have been disconnected from the website. For security reasons, connection is limited to one hour."
        v-if="disconnected"
        type="info"
      />
    </div>
    <header class="header">
      <div class="left">
        <img alt="EMPIR" src="../assets/EMPIR-Euramet-Europe.jpg">
        <p>
          <!-- This project has received funding from the EMPIR programme
          co-financed by the Participating States and from the European
          Union’s Horizon 2020 research and innovation programme. -->
        </p>
      </div>
      <div class="right">
        <img alt="EMPIR" src="../assets/Logo_Pollen_bleu.png">
      </div>
      <div class="end" />
    </header>
    <div class="main">
      <h1 class="title">Web portal Zenodo for EMPIR Project</h1>
      <p class="presentation">
        In order to normalize the file uploaded on Zenodo for partners
        of the EMPIR Project, please use this web portal.
      </p>
    </div>
    <div class="call-to-action">
      <el-button @click="connect()" type="primary">Connect with Zenodo</el-button>
    </div>
    <div class="main">
      <p class="help">
        For security reasons, your connection using Zenodo only last one hour.
      </p>
    </div>
    <Footer fixed />
  </div>
</template>

<script>

import Footer from './Footer.vue'

export default {
  name: 'Connect',
  props: {
    zenodoAuth: Object,
  },
  data() {
    const user = this.$cookies.get('user')
    return {
      uri: '',
      disconnected: user && !user.manualDisconnection,
    }
  },
  mounted() {
    this.uri = this.zenodoAuth.token.getUri()
  },
  methods: {
    connect() {
      const user = this.$cookies.get('user')
      if (user) {
        user.accessToken = null
        this.$cookies.set('user', user)
      }
      window.location = this.uri // this.zenodoAuth.token.getUri()
    },
  },
  components: {
    Footer,
  },
}
</script>
<style lang="scss">

@import "../themes.scss";

$logoHeight: 70px;


.connect {
  flex: 1 1 auto;
  height: 100%;
  padding-top: 30px;
  box-sizing: border-box;

  .alertContainer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  .main {
    color: $primary;

    .presentation {
      max-width: 500px;
      margin: auto;
      padding: 10px;
    }

    .help {
      max-width: 500px;
      margin: auto;
      padding: 10px;
      font-size: 0.8em;
    }
  }


  .title {
  }

  .header {
    padding: 10px;
    text-align: left;
    .left {
      float: left;
      display: inline-block;
      text-align: left;
      font-size: 0.8em;
      font-style: italic;
      img {
        height: $logoHeight;
      }
    }

    .right {
      float: right;
      img {
        height: 50px;
      }
    }

    .end {
      clear: both;
    }
  }

  .call-to-action {
    padding: 30px 0px;
  }
}
</style>
